<template>
  <Transition
    :enter-from-class="$style.appearEnterFrom"
    :enter-active-class="$style.appearEnterActive"
    :leave-to-class="$style.appearLeaveTo"
    :leave-active-class="$style.appearLeaveActive"
  >
    <slot />
  </Transition>
</template>

<style lang="scss" module>
.appearEnterFrom,
.appearLeaveTo {
  opacity: 0;
}

.appearEnterActive,
.appearLeaveActive {
  transition: opacity 0.2s ease-in-out;
}
</style>
